import { locale } from 'devextreme/localization';
import { Component, HostBinding, OnDestroy, } from '@angular/core';
import { AppInfoService, AuthService, ScreenService, ThemeService } from './services';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
	@HostBinding('class') get getClass() {
		return Object.keys(this.screen.sizes).filter((cl) => this.screen.sizes[cl]).join(' ');
	}

	constructor(private authService: AuthService,
		private themeService: ThemeService,
		private screen: ScreenService,
		public appInfo: AppInfoService
	) {
		themeService.setAppTheme();
		locale(navigator.language || 'hu');
	}

	isAuthenticated() {
		return this.authService.loggedIn;
	}

	ngOnDestroy(): void {
		this.screen.breakpointSubscription.unsubscribe();
	}
}
